// extracted by mini-css-extract-plugin
export default {"overlay":"OverPage_overlay__ShH9P","spinner":"OverPage_spinner__hNfHK"};